/**
 * Surfaces inbox/ops API errors (errors with optional `status`).
 *
 * Auth/authz outcomes are owned elsewhere and must stay SILENT here so that a
 * transient introspection blip during load never pops a toast:
 *  - 401 (session) → the refresh coordinator owns it (shows the modal only on a
 *    definitive refresh-token rejection).
 *  - 403 (page access) → the route guard (DashboardPageAccess) owns it; raw
 *    server codes like "workspace_roles_required" or "WORKSPACE_ACCESS_DENIED"
 *    must never be toasted.
 * Both are logged for diagnostics only.
 *
 * @param {unknown} e
 * @param {{ skipAuthRedirect?: boolean }} [opts] Kept for compatibility.
 */
export function surfaceInboxHttpError(e, opts = {}) {
  void opts;
  if (!e || typeof e !== "object") return;
  const status = "status" in e && typeof e.status === "number" ? e.status : undefined;
  if (status === 401 || status === 403) {
    if (typeof console !== "undefined" && console.debug) {
      console.debug("[inbox] suppressed auth error", status, e && e.message);
    }
    return;
  }
}
